module.exports = __webpack_public_path__ + "static/img/pg1.8bf48b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pg1.png
// module id = KsgW
// module chunks = 1